import { getDoveClient } from '../../clients/doveClient';
import { PaginatedResult, PaginationParams, serializePagination } from '../../pagination';
import { ScroogeProperty } from '../dtos/scrooge';
import { serializeParams } from '../utils/serializer';

export async function getScroogePropertyById(id: number): Promise<ScroogeProperty> {
  const doveClient = await getDoveClient();

  const { data } = await doveClient.get<ScroogeProperty>(`/api/v4/properties/${id}`);

  return data;
}

export interface GetScroogePropertiesFilters {
  id?: number | number[],
}

export async function getScroogeProperties(
  filters?: GetScroogePropertiesFilters,
  pagination: PaginationParams = { size: 20 },
): Promise<PaginatedResult<ScroogeProperty>> {
  const doveClient = await getDoveClient();

  const { data } = await doveClient.get<PaginatedResult<ScroogeProperty>>('/api/v4/properties', {
    params: {
      ...serializeParams(filters),
      ...serializePagination(pagination),
    },
  });

  return data;
}
